module.exports = __webpack_public_path__ + "img/hr-car-turret-1.99196fd5.png";